import Util from '../../lib/util';
import { Store, Module, ActionContext } from 'vuex'
import ajax from '../../lib/ajax'
import { eventBus } from '@/lib/eventbus'
import tools from "@/lib/tools"
import appConst from "@/lib/appconst"
import {AppStateBase,INPUT_WIN_PARAM,openWinCom} from "./mod-com"
import {routers} from "@/router/router";

interface AppState extends AppStateBase {
    routers:Array<Router> //缓存的临时文件
}

class AppModule implements Module<AppState, any>{
    namespaced = true;
    self = this;
    state = {
        routers:[]
    };
    mutations = {
        entry(state:AppState,router:Router){
            if(router.meta.level){
                _.remove(state.routers,(n)=>{return n.meta.level>=router.meta.level});
                state.routers.push(router);
            }
        },
        getRoutes(state:AppState){
            return state.routers;
        }
    }
    actions = {

    }
}
const mod = new AppModule();
export default mod;
